// Custom @xyflow/react node. Renders the screen card with an entry pip and
// the route label. Designed to read at a glance per dashboard-shell.md Q1.

import { Handle, Position } from '@xyflow/react'

export function FlowNode({ data, selected }) {
  return (
    <div
      className={[
        'w-[220px] rounded-md border bg-[var(--color-limestone)] px-3 py-2 text-left text-sm shadow-sm transition-colors',
        selected
          ? 'border-[var(--color-terracotta)] ring-2 ring-[var(--color-terracotta)] ring-offset-2 ring-offset-[var(--color-limestone)]'
          : 'border-[var(--color-sandstone)] hover:border-[var(--color-schist)]',
      ].join(' ')}
    >
      <Handle type="target" position={Position.Top} className="!bg-[var(--color-schist)]" />
      <div className="flex items-center gap-2">
        {data.isEntry && (
          <span
            aria-label="Entry node"
            title="Entry node"
            className="inline-block h-1.5 w-1.5 rounded-full bg-[var(--color-terracotta)]"
          />
        )}
        <span className="truncate font-medium text-[var(--color-basalt)]">{data.label}</span>
      </div>
      {data.route && (
        <div className="mt-1 truncate font-mono text-xs text-[var(--color-schist)]">
          {data.route}
        </div>
      )}
      {(data.asserts?.length ?? 0) > 0 && (
        <div className="mt-2 flex flex-wrap gap-1">
          {data.asserts.slice(0, 3).map((a, i) => (
            <span
              key={`${data.label}-assert-${i}`}
              className="rounded-sm bg-[var(--color-sandstone)] px-1.5 py-0.5 text-[10px] uppercase tracking-wider text-[var(--color-slate)]"
            >
              {a.role ?? a.text ?? 'assert'}
            </span>
          ))}
        </div>
      )}
      <Handle type="source" position={Position.Bottom} className="!bg-[var(--color-schist)]" />
    </div>
  )
}
